import { showCollabToast } from "../components/ui/CollabToast";
import { patchThreadAnchor } from "../api";
import { useCollaborateStore } from "../store/useCollaborateStore";
import { normalizeCollaborateThread } from "./normalizeCollaborateThread";
import type { AnchorDescriptor } from "./collaborateAnchor";
import { focusAnchor, isAnchorSupported } from "./collaborateAnchor";

export { isAnchorSupported };

export async function jumpToThreadAnchor(
  threadId: string,
  anchor: AnchorDescriptor,
  currentVersionId: string,
): Promise<void> {
  if (!isAnchorSupported()) {
    showCollabToast.info("Jump to text is not supported in this version of Word.");
    return;
  }

  const result = await focusAnchor(anchor, currentVersionId);
  if (result.resolve === "notfound") {
    showCollabToast.warning("This text is no longer in this version.");
    return;
  }

  if (result.resolve === "approx") {
    showCollabToast.info("Jumped to an approximate location in the document.");
  }

  if (result.resolve === "search" || result.resolve === "approx") {
    try {
      const updated = await patchThreadAnchor(threadId, result.anchor);
      if (updated) {
        useCollaborateStore.getState().applyThreadFromServer(normalizeCollaborateThread(updated));
      }
    } catch {
      // Scroll succeeded; self-heal is best-effort.
    }
  }
}
